import { useMemo } from 'react'
import { Select } from 'antd'
import styled from 'styled-components'

type SelectProductGroupProps = {
  selectedProductGroupId: string
  setSelectedProductGroupId: (productGroupId: string) => void
  productGroups: any[]
}

type SelectOption = {
  label: string
  value: string
  ref: string
}

export function SelectProductGroup({
  selectedProductGroupId,
  setSelectedProductGroupId,
  productGroups
}: SelectProductGroupProps) {
  const selectableProductGroups: SelectOption[] = useMemo(() => {
    return [
      {
        label: '-- Not set --',
        value: '',
        ref: 'not-set'
      },
      ...productGroups.map(pg => ({
        label: pg.name,
        value: pg.productGroupId ? pg.productGroupId : '',
        ref: pg.productGroupId ? pg.productGroupId : ''
      }))
    ]
  }, [productGroups])

  const handleOnChange = (value: any) => {
    setSelectedProductGroupId(value)
  }

  return (
    <StyledSelect
      id={'productGroupSelect'}
      value={selectedProductGroupId ? selectedProductGroupId : undefined}
      allowClear
      showSearch
      placeholder="Select product group"
      options={selectableProductGroups}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      onChange={handleOnChange}
    />
  )
}

const StyledSelect = styled(Select)`
  width: 16.5rem;
`
